import { useContext } from 'react';
import { RightsContext } from './RightsContext';

export const usePermission = authorizationCode => {
  const { rights } = useContext(RightsContext);
  return Boolean(rights?.rights?.find(right => right === authorizationCode));
};

export const usePermissions = authorizationCodes => {
  const { rights: rightsInfo } = useContext(RightsContext);
  if (!authorizationCodes) return false;
  if (authorizationCodes.length === 0) return true;
  return authorizationCodes.every(code => rightsInfo?.rights?.includes(code));
};
